import {ExternalUserType} from 'hemwb-api';

export const getExternalUserInputTypeLabel = (type: ExternalUserType) => {
  if (type === ExternalUserType.VENDOR) {
    return 'Vendor';
  }

  if (type === ExternalUserType.HTA) {
    return 'Health Technology Assessment Representative';
  }

  if (type === ExternalUserType.OTHER) {
    return 'Other';
  }

  return '';
};

const subModelAccessRoles = {
  CALIBRATION: 'Calibration',
  SCENARIO: 'Scenario',
  DISPLAY: 'Display',
};

export const getSubModelAccessType = (role: string) => {
  // @ts-expect-error: adjusting the type error
  return subModelAccessRoles[role];
};
